var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11848_44195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57707 2.00127L14.9277 13.0013C14.9862 13.1026 15.0171 13.2176 15.0171 13.3346C15.0171 13.4516 14.9863 13.5666 14.9277 13.6679C14.8692 13.7693 14.7851 13.8534 14.6837 13.912C14.5824 13.9705 14.4674 14.0013 14.3504 14.0013H1.64907C1.53205 14.0013 1.41709 13.9705 1.31574 13.912C1.2144 13.8534 1.13024 13.7693 1.07173 13.6679C1.01322 13.5666 0.982421 13.4516 0.982422 13.3346C0.982423 13.2176 1.01323 13.1026 1.07174 13.0013L7.4224 2.00127C7.48092 1.89993 7.56508 1.81578 7.66642 1.75728C7.76776 1.69877 7.88272 1.66797 7.99974 1.66797C8.11676 1.66797 8.23171 1.69877 8.33306 1.75728C8.4344 1.81578 8.51856 1.89993 8.57707 2.00127ZM7.33307 10.6679V12.0013H8.6664V10.6679H7.33307ZM7.33307 6.00127V9.33461H8.6664V6.00127H7.33307Z",
    fill: "#DC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11848_44195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFill);
export default __webpack_public_path__ + "static/media/alert-fill.76d5ec935b1358ff8b64fd1de0f5c7c6.svg";
export { ForwardRef as ReactComponent };